// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const PUT_PAYMENT_INSURANCE_INVOICE =
  'v1/paymentInsurance/PUT_PAYMENT_INSURANCE_INVOICE';

export type PutPaymentInvoiceSuccess = ApiSuccess<[], *>;

export const setPaymentToInvoice = (
  journeyId: number,
  token: string
): AsyncAction => {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(PUT_PAYMENT_INSURANCE_INVOICE),
    callAPI: () =>
      axios
        .put(
          `${cfg.bookingServiceUrl}/insurance/payment/invoice/${journeyId}`,
          null,
          config
        )
        .then((res) => res.data),
  };
};
